<template>
  <div class="flex h-screen bg-background">
    <MainContent />
  </div>
</template>

<script setup lang="ts">
import MainContent from '@/components/MainContent.vue'
</script>